import React, { useEffect, useState } from "react";
import Logo from "assets/images/svg-icons/bigfootDriveLogo.svg";
import { MuiBox, MuiTypography } from "components/atoms";
import { useTranslation } from "react-i18next";

function LazyLoading() {
  const [dots, setDots] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length === 5 ? "" : prev + "."));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <MuiBox
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <MuiBox
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          width: "fit-content",
        }}
      >
        <MuiBox sx={{ width: "80px", height: "80px" }}>
          <img src={Logo} alt="Loading..." className="img-full" />
        </MuiBox>

        <MuiTypography variant="16" color="text.darkBlack" fontWeight="500">
          {t("common.loading")}
          <span
            style={{
              display: "inline-block",
              width: "1.5em",
              textAlign: "left",
            }}
          >
            {dots}
          </span>
        </MuiTypography>
      </MuiBox>
    </MuiBox>
  );
}

export default LazyLoading;
